import { Component, ContentChild, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { ExportService } from '../../services/export.service';
import { IPaginate } from '../../modules/pagination/paginate.pipe';
import { SearchFields } from '../search-filter/search-filter.component';
import { momentCustomInstance as moment } from '@projects/shared/src/app/utils/helper';
import { ParticipantChannelType } from '../../features/chat/interfaces/transcript/ConversationAndOfflineMessagesResponse';
import { ToastService } from '../../services/toast/toast.service';
import { CallMonitorService } from '@projects/supervisor/src/app/services/call-monitor.service';

@Component({
  selector: 'data-grid',
  templateUrl: './data-grid.component.html',
  styleUrls: ['./data-grid.component.scss'],
})
export class DataGridComponent implements OnInit {
  @ContentChild('action') action: any = '';
  @ContentChild('bodyDetail') bodyDetail!: TemplateRef<any>;
  @Input() class: string = '';
  @Input() titleHeading: string = '';
  @Input() isFiltersEnabled = true;
  @Input() isRefreshEnabled = false;
  @Input() isExportEnabled = false;
  @Input() isCalendarEnabled = true;
  @Input() isAdvanceCalendar = true;
  @Input() colNames: any = [];
  @Input() columnsData: Array<ColumnsData> = [];
  @Input() rowsData: Array<any> = [];
  @Input() pagingConfig!: IPaginate;
  @Input() tableFilterCallback: ((field: string, value: boolean) => void) | undefined;
  @Input() customTBoday: boolean = false;
  @Input() searchFieldsCallback: ((fields: string, fieldValues: string) => void) | undefined;
  @Input() searchFields: Array<SearchFields> = [];

  @Output() onApplyDate = new EventEmitter();
  @Output() onExport = new EventEmitter();
  @Output() onColSort = new EventEmitter();
  @Output() onPageChange = new EventEmitter();
  @Output() onPageSizeChange = new EventEmitter();
  @Output() onLocalSearch = new EventEmitter();
  @Output() onClearLocalSearch = new EventEmitter();

  showSearchBox = false;
  showColFilter = false;
  showFilters = false;
  emailStatus = EmailStatus;
  moment = moment;

  constructor(private exportService: ExportService, private toastService: ToastService, private callMonitorService: CallMonitorService) {}

  ngOnInit(): void {}

  onClickOutSide(e: any) {
    this.showSearchBox = false;
    this.showColFilter = false;
  }

  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  toggleColFilter() {
    this.showColFilter = !this.showColFilter;
    this.showSearchBox = false;
  }

  setTableField(event: any, fieldName: string) {
    if (this.tableFilterCallback !== undefined) {
      this.tableFilterCallback(fieldName, event.target.checked);
      return;
    }
  }

  handleSearchFields() {
    let fields = this.searchFields
      .filter((f) => f.Value !== '')
      .map((d) => d.FieldName)
      .join(',');
    let fieldValues = this.searchFields
      .filter((f) => f.Value !== '')
      .map((d) => d.Value)
      .join(',');
    if (this.searchFieldsCallback !== undefined) {
      this.searchFieldsCallback(fields, fieldValues);
      return;
    }
  }

  handlePageChange(event: any) {
    this.onPageChange.emit(event);
  }

  handlePageSizeChange(event: any) {
    this.onPageSizeChange.emit(event);
  }

  handleApply(event: any) {
    this.onApplyDate.emit(event.values);
  }

  handleColSort(e: any) {
    this.onColSort.emit(e);
  }

  handleExport() {
    // console.log(new Date().toLocaleString() + '  ➤  rowsData ==> ', this.rowsData);
    if (this.rowsData && this.rowsData.length == 0) {
      this.toastService.info('No data to export!');
      return;
    }
    this.onExport.emit({ exportCallback: this.exportCallback.bind(this) });
  }

  exportCallback(obj: ExportData): void {
    this.exportService.exportToCsv(obj.Data, obj.FileName, obj.Columns);
  }

  getActionIconsCols() {
    const col = ['point75', '1point5', '2', '3'];
    let colIndex = -1;

    this.isFiltersEnabled && colIndex++;
    this.isRefreshEnabled && colIndex++;
    this.isExportEnabled && colIndex++;
    this.colNames && this.colNames.length > 0 && colIndex++;

    return colIndex > -1 && colIndex < col.length ? col[colIndex] : '';
  }

  getNameInitials(name: string) {
    if (!name) return '';

    const words = name.split(' ');
    let initials = '';

    // Get the first character of each word for the first two words
    initials = words
      .slice(0, 2)
      .map((word) => word[0])
      .join('');

    return initials === '' ? 'FD' : initials;
  }

  handleLocalFilter = (field: string, fieldValue: string, criteria: string): void => {
    this.onLocalSearch.emit(fieldValue);
  };
  handleClearLocalFilter = (): void => {
    this.onClearLocalSearch.emit();
  };

  getChannnelIconByType(channelType: number) {
    return channelType == ParticipantChannelType.Web
      ? 'fa-light fa-globe font-social-icon social-icon'
      : channelType == ParticipantChannelType.Messenger
      ? 'fa-brands fa-facebook-messenger font-social-icon social-icon social-icon--fb'
      : channelType == ParticipantChannelType.Instagram
      ? 'fa-brands fa-instagram font-social-icon social-icon social-icon--fb'
      : channelType == ParticipantChannelType.WhatsApp
      ? 'fa-brands fa-whatsapp font-social-icon social-icon social-icon--wa'
      : 'fa-regular fa-comment-sms font-social-icon social-icon social-icon--wa';
  }
  getClosedIcon(dateClosed: Date) {
    return dateClosed == null || dateClosed == undefined
      ? 'fa-light social-icon fa-unlock social-icon--gray social-icon--75x'
      : 'fa-light social-icon fa-lock social-icon--gray social-icon--75x';
  }
}

interface ColumnsData {
  name: string;
  key: string;
  sort: boolean;
  display: boolean;
}

export interface Fields {
  Name: string;
  Value: string;
  Type: string;
}
export interface FieldsCriteria {
  Name: string;
  Value: string;
}
export interface ExportData {
  Data: object[];
  FileName: string;
  Columns?: string[];
}

enum EmailStatus {
  Sent = 0,
  Failed = 1,
  NotSent = 2,
}
